export const setFranchiserHomeButton = (item) => ({
    type: 'SET_FRANCHISER_HOME_BUTTON',
    payload: item,
});